import type { ComplexTab } from "@/domains/navigation/components/complex-breadcrumb-dropdown"
import { CL_PRODUCT_COPY } from "@/domains/manual-cl-page/cl-product-copy"
import { ComplexBreadcrumbDropdown } from "@/domains/navigation/components/complex-breadcrumb-dropdown"
import { ComplexBreadcrumbItem } from "@/domains/navigation/types/complex-breadcrumb-item"

const MANUAL_CL_MANAGE_TABS: ComplexTab[] = [
  {
    id: "overview",
    label: "Overview",
    tabLabel: "Overview",
    description: "View position details",
    slug: "",
  },
  {
    id: "increase",
    label: "Add",
    tabLabel: "Add",
    description: "Add to this position",
    slug: "/increase",
  },
  {
    id: "decrease",
    label: "Remove",
    tabLabel: "Remove",
    description: "Remove liquidity",
    slug: "/decrease",
  },
  {
    id: "collect",
    label: "Fees",
    tabLabel: "Fees",
    description: "Collect earned fees",
    slug: "/collect",
  },
  {
    id: "close",
    label: "Close",
    tabLabel: "Close",
    description: "Close position",
    slug: "/close",
  },
  {
    id: "history",
    label: "History",
    tabLabel: "History",
    description: "View position history",
    slug: "/history",
  },
]

export const ManualClV1ManagePagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "manual-cl-v1-manage-pages",
  render: () => <ManualClV1ManagePagesComplexBreadcrumbApplicationComponent />,
}

export const ManualClV1ManagePagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown
      tabs={MANUAL_CL_MANAGE_TABS}
      navigationMode="slug"
      invalidTabMessage={`Invalid ${CL_PRODUCT_COPY.v1.shortName} tab`}
    />
  )
}
